import React from 'react';

import {
  FormControl,
  Input,
  Grid,
  Text,
  Heading,
  Select,
  FormErrorMessage,
} from '@chakra-ui/react';

import { FormErrors, Fields, Header } from '../types';

type FieldsTabProps = {
  headers: Header;
  actualHeaders: string[];
  headerRow: number;
  errors: FormErrors;
  fields: Fields;
  setFields: React.Dispatch<React.SetStateAction<Fields>>;
};

const FieldsTab: React.FC<FieldsTabProps> = ({
  headers,
  actualHeaders,
  headerRow,
  errors,
  fields,
  setFields,
}) => {
  return (
    <>
      <Heading as="h3" fontWeight="medium" fontSize="md" mb={4}>
        Indique a coluna do arquivo importado que corresponda a cada campo do
        orçamento
      </Heading>

      <Grid
        w="100%"
        templateColumns="repeat(auto-fit, minmax(250px, 1fr))"
        columnGap={2}
        rowGap={4}
      >
        <Text fontWeight="bold" mb={4}>
          Orçamento
        </Text>
        <Text fontWeight="bold" mb={4}>
          Arquivo importado (Colunas)
        </Text>
      </Grid>

      <Grid
        w="100%"
        templateColumns="repeat(auto-fit, minmax(250px, 1fr))"
        columnGap={2}
        rowGap={4}
      >
        <FormControl>
          <Input
            type="text"
            value="Item (1.1, 1.2, etc.)"
            readOnly
            _readOnly={{ background: 'white' }}
          />
        </FormControl>

        <FormControl isInvalid={!!errors?.item}>
          <Select
            value={fields.item}
            onChange={(e) => {
              setFields({ ...fields, item: e.target.value });
            }}
          >
            <option value="">Selecione</option>
            {actualHeaders.map((column) => (
              <option key={String(column)} value={column}>
                {column}
                {headerRow} - {headers[column]}
              </option>
            ))}
          </Select>

          <FormErrorMessage>
            {!!errors?.item && 'Item é obrigatório'}
          </FormErrorMessage>
        </FormControl>

        <FormControl>
          <Input
            type="text"
            value="Tipo"
            readOnly
            _readOnly={{ background: 'white' }}
          />
        </FormControl>

        <FormControl isInvalid={!!errors?.type}>
          <Select
            value={fields.type}
            onChange={(e) => {
              setFields({ ...fields, type: e.target.value });
            }}
          >
            <option value="">Selecione</option>
            {actualHeaders.map((column) => (
              <option key={String(column)} value={column}>
                {column}
                {headerRow} - {headers[column]}
              </option>
            ))}
          </Select>

          <FormErrorMessage>
            {!!errors?.type && 'Tipo é obrigatório'}
          </FormErrorMessage>
        </FormControl>

        <FormControl>
          <Input
            type="text"
            value="Código"
            readOnly
            _readOnly={{ background: 'white' }}
          />
        </FormControl>

        <FormControl isInvalid={!!errors?.code}>
          <Select
            value={fields.code}
            onChange={(e) => {
              setFields({ ...fields, code: e.target.value });
            }}
          >
            <option value="">Selecione</option>
            {actualHeaders.map((column) => (
              <option key={String(column)} value={column}>
                {column}
                {headerRow} - {headers[column]}
              </option>
            ))}
          </Select>

          <FormErrorMessage>
            {!!errors?.code && 'Código é obrigatório'}
          </FormErrorMessage>
        </FormControl>

        <FormControl>
          <Input
            type="text"
            value="Base"
            readOnly
            _readOnly={{ background: 'white' }}
          />
        </FormControl>

        <FormControl isInvalid={!!errors?.base}>
          <Select
            value={fields.base}
            onChange={(e) => {
              setFields({ ...fields, base: e.target.value });
            }}
          >
            <option value="">Selecione</option>
            {actualHeaders.map((column) => (
              <option key={String(column)} value={column}>
                {column}
                {headerRow} - {headers[column]}
              </option>
            ))}
          </Select>

          <FormErrorMessage>
            {!!errors?.base && 'Base é obrigatória'}
          </FormErrorMessage>
        </FormControl>

        <FormControl>
          <Input
            type="text"
            value="Descrição"
            readOnly
            _readOnly={{ background: 'white' }}
          />
        </FormControl>

        <FormControl isInvalid={!!errors?.description}>
          <Select
            value={fields.description}
            onChange={(e) => {
              setFields({ ...fields, description: e.target.value });
            }}
          >
            <option value="">Selecione</option>
            {actualHeaders.map((column) => (
              <option key={String(column)} value={column}>
                {column}
                {headerRow} - {headers[column]}
              </option>
            ))}
          </Select>

          <FormErrorMessage>
            {!!errors?.description && 'Descrição é obrigatória'}
          </FormErrorMessage>
        </FormControl>

        <FormControl>
          <Input
            type="text"
            value="Coeficiente"
            readOnly
            _readOnly={{ background: 'white' }}
          />
        </FormControl>

        <FormControl isInvalid={!!errors?.coefficient}>
          <Select
            value={fields.coefficient}
            onChange={(e) => {
              setFields({ ...fields, coefficient: e.target.value });
            }}
          >
            <option value="">Selecione</option>
            {actualHeaders.map((column) => (
              <option key={String(column)} value={column}>
                {column}
                {headerRow} - {headers[column]}
              </option>
            ))}
          </Select>

          <FormErrorMessage>
            {!!errors?.coefficient && 'Coeficiente é obrigatório'}
          </FormErrorMessage>
        </FormControl>

        <FormControl>
          <Input
            type="text"
            value="Unidade de medida"
            readOnly
            _readOnly={{ background: 'white' }}
          />
        </FormControl>

        <FormControl isInvalid={!!errors?.unit_measure}>
          <Select
            value={fields.unit_measure}
            onChange={(e) => {
              setFields({ ...fields, unit_measure: e.target.value });
            }}
          >
            <option value="">Selecione</option>
            {actualHeaders.map((column) => (
              <option key={String(column)} value={column}>
                {column}
                {headerRow} - {headers[column]}
              </option>
            ))}
          </Select>

          <FormErrorMessage>
            {!!errors?.unit_measure && 'Unidade de medida é obrigatória'}
          </FormErrorMessage>
        </FormControl>
      </Grid>
    </>
  );
};

export default FieldsTab;
